var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgZoom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_176_238",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 14,
    height: 14
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H14V14H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_176_238)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 7C14 10.8657 10.8657 14 7 14C3.13425 14 0 10.8657 0 7C0 3.13425 3.13425 0 7 0C10.8657 0 14 3.13425 14 7ZM3.5 9.45H8.75V5.6C8.75 5.46211 8.72284 5.32557 8.67007 5.19818C8.61731 5.07079 8.53996 4.95504 8.44246 4.85754C8.34496 4.76004 8.22921 4.68269 8.10182 4.62993C7.97443 4.57716 7.83789 4.55 7.7 4.55H2.45V8.4C2.45 8.67848 2.56062 8.94555 2.75754 9.14246C2.85504 9.23996 2.97079 9.31731 3.09818 9.37007C3.22557 9.42284 3.36211 9.45 3.5 9.45ZM9.45 8.05L11.55 9.45V4.55L9.45 5.95V8.05Z",
    fill: "#FFFEFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoom);
export default __webpack_public_path__ + "static/media/zoom.6638a97385d3859b30a7dadeeee62670.svg";
export { ForwardRef as ReactComponent };